export const NGO_USER_REQUIRED_REQUEST = 'NGO_USER_REQUIRED_REQUEST'
export const NGO_USER_REQUIRED_SUCCESS = 'NGO_USER_REQUIRED_SUCCESS'
export const NGO_USER_REQUIRED_FAIL = 'NGO_USER_REQUIRED_FAIL'
export const NGO_USER_LOGOUT = 'NGO_USER_LOGOUT'

export const REQUEST_LIST_FAIL = 'REQUEST_LIST_FAIL'
export const REQUEST_LIST_SUCCESS = 'REQUEST_LIST_SUCCESS'
export const REQUEST_LIST_REQUEST = 'REQUEST_LIST_REQUEST'

export const MY_REQUEST_LIST_FAIL = 'MY_REQUEST_LIST_FAIL'
export const MY_REQUEST_LIST_SUCCESS = 'MY_REQUEST_LIST_SUCCESS'
export const MY_REQUEST_LIST_REQUEST = 'MY_REQUEST_LIST_REQUEST'

export const REQUEST_DELETE_REQUEST = 'REQUEST_DELETE_REQUEST'
export const REQUEST_DELETE_SUCCESS = 'REQUEST_DELETE_SUCCESS'
export const REQUEST_DELETE_FAIL = 'REQUEST_DELETE_FAIL'

export const NGO_USER_DETAILS_REQUEST = 'NGO_USER_DETAILS_REQUEST'
export const NGO_USER_DETAILS_SUCCESS = 'NGO_USER_DETAILS_SUCCESS'
export const NGO_USER_DETAILS_FAIL = 'NGO_USER_DETAILS_FAIL'
export const NGO_USER_DETAILS_RESET = 'NGO_USER_DETAILS_RESET'

export const NGO_USER_UPDATE_PROFILE_REQUEST = 'NGO_USER_UPDATE_PROFILE_REQUEST'
export const NGO_USER_UPDATE_PROFILE_SUCCESS = 'NGO_USER_UPDATE_PROFILE_SUCCESS'
export const NGO_USER_UPDATE_PROFILE_FAIL = 'NGO_USER_UPDATE_PROFILE_FAIL'
export const NGO_USER_UPDATE_PROFILE_RESET = 'NGO_USER_UPDATE_PROFILE_RESET'

export const NGO_USER_LIST_REQUEST = 'NGO_USER_LIST_REQUEST'
export const NGO_USER_LIST_SUCCESS = 'NGO_USER_LIST_SUCCESS'
export const NGO_USER_LIST_FAIL = 'NGO_USER_LIST_FAIL'
export const NGO_USER_LIST_RESET = 'NGO_USER_LIST_RESET'

export const NGO_USER_DELETE_REQUEST = 'NGO_USER_DELETE_REQUEST'
export const NGO_USER_DELETE_SUCCESS = 'NGO_USER_DELETE_SUCCESS'
export const NGO_USER_DELETE_FAIL = 'NGO_USER_DELETE_FAIL'

export const NGO_USER_UPDATE_REQUEST = 'NGO_USER_UPDATE_REQUEST'
export const NGO_USER_UPDATE_SUCCESS = 'NGO_USER_UPDATE_SUCCESS'
export const NGO_USER_UPDATE_FAIL = 'NGO_USER_UPDATE_FAIL'
export const NGO_USER_UPDATE_RESET = 'NGO_USER_UPDATE_RESET'
